import React from 'react';
import { Box, Typography } from '@mui/material';
import { PRES, SPACE, TYPE } from '../chrome';

interface AdminSectionHeaderProps {
  title: string;
  intro: string;
  consequence: string;
}

const AdminSectionHeader: React.FC<AdminSectionHeaderProps> = ({ title, intro, consequence }) => (
  <Box sx={{ mb: `${SPACE[5]}px` }}>
    <Typography
      component="h2"
      sx={{ color: PRES.textPrimary, fontFamily: TYPE.ui, ...TYPE.title, mb: 0.75 }}
    >
      {title}
    </Typography>
    <Typography sx={{ color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.body, mb: 0.75, maxWidth: 720 }}>
      {intro}
    </Typography>
    <Typography sx={{ color: PRES.textTertiary, fontFamily: TYPE.ui, ...TYPE.meta, maxWidth: 720 }}>
      {consequence}
    </Typography>
  </Box>
);

export default AdminSectionHeader;
